export function getBobaMePublicUrl(domain: string): string {
  return `https://${domain}.bobaboba.me`
}
